import { useState } from "react";
import TryItemsPanel from "./try-items-panel";
import MarketsPanel from "./markets-panel";
import WeightsPanel from "./weights-panel";

type Tab = "try" | "weights" | "markets";

export default function SearchConfig() {
  const [tab, setTab] = useState<Tab>("try");

  return (
    <div className="container-fluid">
      <ul className="nav nav-tabs mb-4">
        <li className="nav-item">
          <button
            className={`nav-link ${tab === "try" ? "active" : ""}`}
            onClick={() => setTab("try")}
          >
            Try searching for
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${tab === "weights" ? "active" : ""}`}
            onClick={() => setTab("weights")}
          >
            Ranking weights
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${tab === "markets" ? "active" : ""}`}
            onClick={() => setTab("markets")}
          >
            Markets
          </button>
        </li>
      </ul>
      {tab === "try" && <TryItemsPanel />}
      {tab === "weights" && <WeightsPanel />}
      {tab === "markets" && <MarketsPanel />}
    </div>
  );
}
